<template>
  <!-- main area -->
  <div class="centerArea_wrapper">
    <Conference :conference="defaultHall" :is-room="false" />
    <Corner v-for="corner in $store.getters['corner/getByHallId'](defaultHall.id)" :key="corner.id" :hall="defaultHall" :corner="corner" />
  </div>
</template>

<script>
import Conference from "../modules/Conference"
import Corner from "../modules/Corner"

export default {
  name: "Top",
  components: {Corner, Conference},
  data() {
    return {
      conference: {},
      corners: {},
      videoPlay: false
    }
  },
  computed: {
    defaultHall() {
      return this.$store.getters["hall/mainOrFirst"]
    }
  }
}
</script>
